import React, { useCallback, useEffect, useState } from "react"
import { Layout, Row, Col, Space, Badge, Tag, Button, Tooltip } from "antd"
import "../../components/css/Topbar.css"
import {
  SyncOutlined,
  EuroCircleOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  EyeOutlined,
} from "@ant-design/icons"
import { useAuthContext } from "../../hooks/useAuthContext"

import { Link } from "react-router-dom"
import { useCollection } from "../../hooks/useCollection"
import { collection, onSnapshot, query, where } from "firebase/firestore"
import { db } from "../../firebase/config"
import { UserTop } from "./Users/UserTop"
import useSidebarTrigger from "../../store/useSidebarTrigger"
import UserSwitcherModal from "../Admin/ViewMode/UserSwitcherModal"
import useViewModeStore from "../../store/viewMode/useViewModeStore"

const { Header } = Layout

export function AdminTopBar() {
  const { user, admin, firestoreData, _isViewMode } = useAuthContext()
  const { exitViewMode } = useViewModeStore()
  const [switcherOpen, setSwitcherOpen] = useState(false)

  const canOversee = admin || firestoreData?.canOverseeUsers

  const [clientCount, setClientCount] = useState(0)
  const [groupCount, setGroupCount] = useState(0)

  const { loading, data } = useCollection(
    "priceCalculation",
    ["aproved", "==", false],
    ["sentBack", "==", false],
  )

  const { data: groupData, loading: groupLoading } = useCollection("clientGroups", [
    "approved",
    "==",
    false,
  ])

  const { sidebarCollapse, setSidebarCollapse } = useSidebarTrigger()

  const getStuff = useCallback(async () => {
    await groupData
    if (!groupLoading) {
      setGroupCount(groupData.filter((item) => item).length)
    }
  }, [groupData, groupLoading])

  useEffect(() => {
    const ref = collection(db, "clients")
    const q = query(ref, where("approved", "==", false), where("tapeClient", "==", false))
    const unsubscribe = onSnapshot(q, (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ ...doc.data(), id: doc.id })
      })
      getStuff()
      setClientCount(results.filter((item) => item).length + groupCount)
    })
    return () => unsubscribe()
  }, [getStuff, groupCount])

  let countPrices = 0
  if (!loading) {
    countPrices = data.filter((item) => item).length
  }

  return (
    <Header
      style={{
        zIndex: 100,
        paddingLeft: 0,
        color: "black",
      }}
      className="topbar-container">
      <Row justify="space-between">
        <Col flex="auto">
          <Button
            type="text"
            icon={sidebarCollapse ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setSidebarCollapse(!sidebarCollapse)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
              color: "white",
            }}
          />
        </Col>
        <Col flex="400px">
          <Space size={35}>
            <Badge count={countPrices && countPrices}>
              <Link to="/unconfirmed-prices">
                <Tag icon={<EuroCircleOutlined />} color="error">
                  uncofirmed prices
                </Tag>
              </Link>
            </Badge>
            <Badge count={clientCount && clientCount}>
              <Link to="/unconfirmed-clients">
                <Tag icon={<SyncOutlined />} color="error">
                  uncofirmed clients
                </Tag>
              </Link>
            </Badge>

            {/* ── View Mode button ── */}
            {canOversee && !_isViewMode && (
              <>
                <Tooltip title="View the app as another user">
                  <Button
                    icon={<EyeOutlined />}
                    onClick={() => setSwitcherOpen(true)}
                    size="small"
                    style={{
                      background: "rgba(255,255,255,0.15)",
                      borderColor: "rgba(255,255,255,0.35)",
                      color: "#fff",
                      marginRight: 15,
                    }}>
                    Change View
                  </Button>
                </Tooltip>
                <UserSwitcherModal open={switcherOpen} onClose={() => setSwitcherOpen(false)} />
              </>
            )}
          </Space>
        </Col>
        <Col flex="none">
          <UserTop user={user} />
        </Col>
      </Row>
    </Header>
  )
}
